const zhCN = {
  creationTime: '人员创建时间：',

  photosTitle: '人员照片信息',
  photoTxt1: '现场照 1',
  photoTxt1Blank: '请上传现场照！',
  photoTxt2: '现场照 2',
  IDCardPhotoTxt: '身份证芯片照',

  takePhotoBtn: '拍照',
  openCameraSuccess: '开启摄像头成功！',
  openCameraFail: '开启摄像头失败！',
  openCameraFailTip: '开启摄像头失败, 未发现拍照设备！',
  openCameraFailTip1: '请确认摄像头是否又被其他程序占用。',
  openCameraFailTip2: '请确认浏览器是否开启摄像头权限。',

  uploadPhotoBtn: '上传',
  uploadImageDesc: '现场照(1)、现场照(2) 的图片格式为jpg、jpeg、png',
  uploadSuccess: '上传成功！',
  uploadFail: '上传失败！',
  submitPhotoFail: '提交照片失败！',

  readIDCardBtn: '读取身份证信息',
  uploadIDCardPhotoFail: '证件照上传失败！',

  basicInfoTitle: '人员基本信息',

  name: '姓名',
  nameTxt: '请输入人员姓名',
  nameBlank: '姓名不能为空！',
  nameWarning: '姓名最多输入20个字！',

  IDType: '证件类型',
  IDTypeTxt: '请选择证件类型',
  IDTypeBlank: '证件类型不能为空！',

  IDNumber: '身份证号',
  IDNumberTxt: '请输入身份证号',
  IDNumberBlank: '身份证号不能为空！',
  IDNumberWarning: '请输入正确的身份证号！',

  passportNumber: '护照证件号',
  passportNumberTxt: '请输入护照证件号',
  passportNumberBlank: '护照证件号不能为空！',

  gatePassNumber: '港澳通行证证件号',
  gatePassNumberTxt: '请输入港澳通行证证件号',
  gatePassNumberBlank: '港澳通行证证件号不能为空！',

  sex: '性别',
  sexTxt: '请选择性别',

  nationality: '民族',
  nationalityTxt: '请选择民族',

  birthday: '出生日期',
  birthdayTxt: '请选择出生日期',

  phone: '手机号',
  phoneTxt: '请输入手机号',
  phoneWarning: '请输入正确的手机号码！',
  phoneBlank: '手机号不能为空！',

  address: '地址',
  addressTxt: '请输入地址',
  addressWarning: '地址名称最多100字！',

  remark: '备注',
  remarkTxt: '请输入备注',
  remarkWarning: '最多输入20个字！',

  ICCardTitle: '门禁卡信息',
  bindICCard: '门禁卡绑定',
  readICCardBtn: '读取门禁卡',

  ICCardModal: '设置门禁卡',
  rechecking: '人员信息查重中...',
  recheckingErr: '人员信息查重错误！',
  recheckingTips: '已被添加到',
  ICCard: '门禁卡',
  ICCardTxt: '请输入门禁卡编号',

  submitBtn: '提交',
  closeBtn: '关闭',

  takePhotoModal: '拍摄现场照',

  pageErrTitle: '页面错误',
  pageErrContent: '信息错误，请返回人员管理列表！',
  backBtn: '返回',

  addPersonalSuccess: '新增人员成功！',
  addPersonalFail: '新增人员失败！',
  editPersonalSuccess: '修改人员成功！',
  editPersonalFail: '修改人员失败！',

  requestInfoFail: '获取人员信息失败！'
}

const enUS = {
  creationTime: 'Creation Time: ',

  photosTitle: 'Personnel Photo',
  photoTxt1: 'Photo 1',
  photoTxt1Blank: 'Please upload live photos!',
  photoTxt2: 'Photo 2',
  IDCardPhotoTxt: 'ID Card Photo',

  takePhotoBtn: 'Camera',
  openCameraSuccess: 'Open camera successfully!',
  openCameraFail: 'Open camera failed!',
  openCameraFailTip: 'Open camera failed, no camera found!',
  openCameraFailTip1: 'Make sure the camera is\'t occupied by another program.',
  openCameraFailTip2: 'Make sure the browser is turn on camera permissions.',

  uploadPhotoBtn: 'Upload',
  uploadImageDesc: 'The format of photos 1 and 2 should be JPG, JPEG or PNG.',
  uploadSuccess: 'upload successfully!',
  uploadFail: 'upload failed!',
  submitPhotoFail: 'Submit photo failed',

  readIDCardBtn: 'Read ID Card',
  uploadIDCardPhotoFail: 'Upload ID card photo failed!',

  basicInfoTitle: 'Personnel Basic Information',

  name: 'Name',
  nameTxt: 'Enter personnel name',
  nameBlank: 'Personnel name can\'t be blank!',
  nameWarning: 'Personnel name is up to 20 words!',

  IDType: 'ID Type',
  IDTypeTxt: 'Choose ID type',
  IDTypeBlank: 'ID type can\'t be blank!',

  IDNumber: 'ID Number',
  IDNumberTxt: 'Enter ID number',
  IDNumberBlank: 'ID number can\'t be blank!',
  IDNumberWarning: 'Please enter the correct ID number!',

  passportNumber: 'Passport Number',
  passportNumberTxt: 'Enter passport number',
  passportNumberBlank: 'Passport number can\'t be blank!',

  gatePassNumber: 'EEP to HK / Macau Number',
  gatePassNumberTxt: 'Enter EEP to HK / Macau number',
  gatePassNumberBlank: 'EEP to HK / Macau number can\'t be blank!',

  sex: 'Sex',
  sexTxt: 'Choose sex',

  nationality: 'Nationality',
  nationalityTxt: 'Choose nationality',

  birthday: 'Birthday',
  birthdayTxt: 'Choose birthday',

  phone: 'Phone',
  phoneTxt: 'Enter phone number',
  phoneWarning: 'Please enter the correct phone number!',
  phoneBlank: 'Phone can\'t be blank!',

  address: 'Address',
  addressTxt: 'Enter address',
  addressWarning: 'Address is up to 20 words!',

  remark: 'Remark',
  remarkTxt: 'Enter remark',
  remarkWarning: 'Remark is up to 20 words!',

  ICCardTitle: 'IC Card',
  bindICCard: 'Bind IC Card',
  readICCardBtn: 'Read IC Card',

  ICCardModal: 'IC Card Setting',
  rechecking: 'Personal information rechecking...',
  recheckingErr: 'Personal information rechecking error!',
  recheckingTips: 'was added in',
  ICCard: 'IC Card',
  ICCardTxt: 'Enter access card number',

  submitBtn: 'Submit',
  closeBtn: 'Close',

  takePhotoModal: 'Take Photo',

  pageErrTitle: 'Page Error',
  pageErrContent: 'Page error, please return to the personal management list!',
  backBtn: 'Back',

  addPersonalSuccess: 'Add personal successfully!',
  addPersonalFail: 'Add personal failed!',
  editPersonalSuccess: 'Edit personal successfully!',
  editPersonalFail: 'Edit personal failed!',

  requestInfoFail: 'Request personal information failed!'
}

export default { zhCN, enUS }
